import { CATEGORIES_PRODUCTS } from '../constants.js'

fetch(`/api/category`)
.then((response)=>{
  return response.json()
})
.then((data)=>{
  data.map((x)=>{
	  x.subcats.map((item)=>{ defaultState.allgender.push(item)}) 
	!x.hide &&  x.gender =="male" ? x.subcats.map((item)=>{ defaultState.men.push(item)})   :
	!x.hide &&  x.gender =="female" ?	x.subcats.map((item)=>{ defaultState.women.push(item)}) :""
  })
})
const defaultState = 
{
	men: [],
	women: [],
	allgender:[]
}

export const categoriesProducts = (state = defaultState, action) => {
  switch (action.type) {
		case CATEGORIES_PRODUCTS:
				return defaultState;

		default:
				return defaultState;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/categoriesProductsReducer.js